import { useEffect, useState } from 'react';

import './style.css';

import http from '../../libs/http';
import alert from '../../libs/alert';

function Conf({ user, setUser }: any) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    init(user);
  }, [user]);

  async function init(user: any) {
    setName(user.name);
    setEmail(user.email);
    setWhatsapp(user.whatsapp ? formatWhatsappInput(user.whatsapp) : '');
  }

  function formatWhatsappInput(value: string): string {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 2) return cleaned;
    if (cleaned.length <= 6) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
    if (cleaned.length <= 10) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7, 11)}`;
  }

  function formatWhatsapp(value: string): string {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 2) return cleaned;
    if (cleaned.length <= 6) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
    if (cleaned.length <= 10) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7, 11)}`;
  }

  function handleWhatsappChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value = e.target.value;
    if (value.length <= 15) {
      setWhatsapp(formatWhatsapp(value));
    }
  }

  function validateBrazilianPhone(phone: string): boolean {
    const cleaned = phone.replace(/\D/g, '');
    return cleaned.length >= 10 && cleaned.length <= 11;
  }

  function getRawWhatsapp(phone: string): string {
    return phone.replace(/\D/g, '');
  }

  async function handleSignUpFormSubmit(event: any) {
    event.preventDefault();
    setLoading(true);

    const url = `${process.env.REACT_APP_API_URL}/api/v1/user/update`;
    const headers = { Authorization: user.token };
    let payload: any = { name, email };

    if (password && password.length) {
      payload.password = password;
    }

    if (whatsapp) {
      if (!validateBrazilianPhone(whatsapp)) {
        alert.error('Por favor, insira um número de WhatsApp válido brasileiro (com DDD)!');
        setLoading(false);
        return;
      }
      payload.whatsapp = getRawWhatsapp(whatsapp);
    }

    const response = await http.post(url, payload, headers);

    if (response.error) {
      alert.error(response.error);
      setLoading(false);
      return;
    }

    setUser({ ...user, name, email, whatsapp: payload.whatsapp || user.whatsapp });
    setLoading(false);
    localStorage.setItem('user', JSON.stringify({ ...user, name, email, whatsapp: payload.whatsapp || user.whatsapp }));
    alert.success('Sucesso! Seus dados foram atualizados!')
  }

  return (
    <div style={{ paddingTop: 32 }}>
      <form onSubmit={handleSignUpFormSubmit}>
        <div>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="App-input mb-10"
            placeholder='Nome'
            required
          />
        </div>
        <div>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="App-input mb-10"
            placeholder='E-mail'
            type='email'
            required
          />
        </div>
        <div>
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="App-input"
            placeholder='Nova Senha'
            autoComplete='new-password'
            type='password'
          />
        </div>
        <div>
          <input
            value={whatsapp}
            onChange={handleWhatsappChange}
            className="App-input mt-10"
            placeholder='WhatsApp (opcional, ex: 11 99999-9999)'
            type='tel'
          />
        </div>
        <button
          className="App-button mt-20"
        >
          { loading ? 'Salvando...' : 'Salvar' }
        </button>
      </form>
    </div>
  );
}

export default Conf;
